import React, { useRef, useState } from "react";
import { useBoundStore } from "../../store/store";
import {
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
  Typography,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import LoginWrapper from "../../components/LoginWrapper";
import i18n from "i18n/i18n";
import { useLocation, useNavigate } from "react-router-dom";
import { bannerJson } from "utils/dummy";
import { BeatLoader } from "react-spinners";

function LoginPage() {
  

  let lang = navigator?.language.split("-")[0]; // e.g "de" from de-DE 

  const navigate = useNavigate();
  const loginUser = useBoundStore((state) => state.loginUser);

  const loginLoader = useBoundStore((state) => state.loginLoader);

  const { setLoginError } = useBoundStore();

  const [showPassword, setShowPassword] = React.useState(false);

  const emailRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);

  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [loader, setLoader] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    setLoginEmail(value);
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    setLoginPassword(value);
  };

  const submitForm = () => {
    if (loginEmail === "") {
      emailRef.current?.focus();
      return;
    }
    if (loginPassword === "") {
      passwordRef.current?.focus();
      return;
    } else {
      setLoader(true);
      loginUser(loginEmail, loginPassword);
    }
  };

  const { search } = useLocation();
  let query = new URLSearchParams(search);

  return (
    <LoginWrapper
      showLogo={true}
      showBanner={query.get("status")}
      bannerContent={bannerJson[Number(query.get("status"))]}
    >
      <div className="content">
        
        <Typography variant="h6" textAlign={"center"}>
          {i18n(lang)?.login_header}
        </Typography>
        <div className="form">
          <TextField
            id="outlined-basic"
            label={i18n(lang)?.eemail}
            variant="outlined"
            className="inputField"
            onChange={handleEmailChange}
            inputRef={emailRef}
            onKeyDown={(ev) => {
              if (ev.key === 'Enter') {
                // Do code here
                ev.preventDefault();
                submitForm();
              }
            }}
          />

          <FormControl
            sx={{ width: "25ch" }}
            variant="outlined"
            className="inputField"
          >
            <InputLabel htmlFor="outlined-adornment-password">
              {i18n(lang)?.password}
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={showPassword ? "text" : "password"}
              inputRef={passwordRef}
              onChange={handlePasswordChange}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label=" tpv "
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label={i18n(lang)?.password}
              onKeyDown={(ev) => {
                if (ev.key === 'Enter') {
                  // Do code here
                  ev.preventDefault();
                  submitForm();
                }
              }}
            />
          </FormControl>
          <Typography
            sx={{
              typography: "subtitle1",
              margin: "5px 0px 0px 14px",
              cursor: "pointer",
            }}
            onClick={() => {
              setLoginError("");
              navigate("/reset-password");
            }}
          >
            {i18n(lang)?.forgot_password}
          </Typography>

          <Button
            fullWidth
            variant="contained"
            disabled={loginLoader}
            className="loginBtn roboto lp125"
            onClick={submitForm}
          >
            {!loginLoader && i18n(lang).loginButton}
            <BeatLoader color={"var(--primary-second-color)"} loading={loginLoader} size={20} />
          </Button>
        </div>
      </div>
    </LoginWrapper>
  );
}

export default LoginPage;
